var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartForecastingAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.518 161.036-61.036-35.239c-.349-.201-.703-.391-1.054-.586h-11.576l-19.574 12.5-10.586 11.075 1.068 4.66-18.555 10.664-22.492 42.374-10.061 39.998 10.061 61.182 30.09 43.039 10.957 7.85v5.37l23.013 19.116 12.259 4.171 5.394-.423c.352-.195.705-.384 1.054-.585l61.038-35.239c21.27-12.28 34.482-35.164 34.482-59.724v-70.479c0-24.559-13.212-47.443-34.482-59.724z",
    fill: "#60b9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.858 255.999c0-57.961 34.228-107.919 83.57-130.787-21.084-11.683-46.989-11.494-67.911.586h.001l-61.037 35.239c-21.269 12.281-34.482 35.165-34.482 59.725v70.479c0 24.56 13.213 47.444 34.482 59.725l61.036 35.239c20.922 12.079 46.827 12.268 67.91.585-49.342-22.871-83.569-72.829-83.569-130.791z",
    fill: "#1ca8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.49 192.261-61.036-35.239c-7.242-4.182-15.733-5.363-23.693-3.577l-18.555 10.664-22.492 42.374-10.061 39.998 10.061 61.182 30.09 43.039 10.957 7.85c7.96 1.786 16.451.605 23.692-3.577l61.037-35.239c10.149-5.86 16.454-16.78 16.454-28.499v-70.479c0-11.717-6.305-22.636-16.454-28.497z",
    fill: "#4d66d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.761 358.554c-26.481-26.124-42.904-62.416-42.904-102.555 0-40.138 16.422-76.429 42.903-102.553-3.195.717-6.307 1.898-9.215 3.577l-61.036 35.239c-10.149 5.86-16.454 16.78-16.454 28.499v70.479c0 11.719 6.305 22.639 16.454 28.499l61.036 35.239c2.909 1.678 6.021 2.859 9.216 3.576z",
    fill: "#2f4dca"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 88.228c-4.267 0-7.726-3.459-7.726-7.726v-56.992c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v56.992c.001 4.267-3.459 7.726-7.726 7.726z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315.391 105.055c-4.267 0-7.726-3.459-7.726-7.726v-42.453c0-11.384 9.262-20.647 20.647-20.647h47.119c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726h-47.119c-2.864 0-5.194 2.33-5.194 5.194v42.453c-.001 4.268-3.46 7.727-7.727 7.727z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.609 105.055c-4.267 0-7.726-3.459-7.726-7.726v-42.453c0-2.864-2.33-5.194-5.194-5.194h-50.797c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h50.797c11.384 0 20.647 9.262 20.647 20.647v42.453c-.001 4.266-3.46 7.725-7.727 7.725z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 491.84c-4.267 0-7.726-3.459-7.726-7.726v-52.615c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v52.615c.001 4.266-3.459 7.726-7.726 7.726z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m375.43 477.771h-47.119c-11.385 0-20.647-9.262-20.647-20.647v-42.453c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v42.453c0 2.864 2.33 5.194 5.194 5.194h47.119c4.267 0 7.726 3.459 7.726 7.726.002 4.267-3.457 7.727-7.725 7.727z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.689 477.771h-50.797c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h50.797c2.864 0 5.194-2.33 5.194-5.194v-42.453c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v42.453c0 11.384-9.262 20.646-20.646 20.646z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m80.502 263.726h-56.992c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h56.992c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m97.329 204.335h-42.453c-11.384 0-20.647-9.262-20.647-20.647v-46.382c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v46.382c0 2.864 2.33 5.194 5.194 5.194h42.453c4.267 0 7.726 3.459 7.726 7.726.001 4.268-3.458 7.727-7.725 7.727z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.956 383.04c-4.267 0-7.726-3.459-7.726-7.726v-47.002c0-11.385 9.262-20.647 20.647-20.647h42.453c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726h-42.454c-2.864 0-5.194 2.33-5.194 5.194v47.002c0 4.268-3.459 7.727-7.726 7.727z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m488.49 263.726h-56.992c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h56.992c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m457.124 204.335h-42.453c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h42.453c2.864 0 5.194-2.33 5.194-5.194v-46.382c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v46.382c.001 11.384-9.261 20.646-20.646 20.646z",
    fill: "#60b9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m470.044 383.04c-4.267 0-7.726-3.459-7.726-7.726v-47.002c0-2.864-2.33-5.194-5.194-5.194h-42.453c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h42.453c11.384 0 20.647 9.262 20.647 20.647v47.002c0 4.266-3.459 7.725-7.727 7.725z",
    fill: "#60b9fe"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#dbedff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.939 211.473c-1.138-3.003-4.014-4.988-7.225-4.988s-6.087 1.986-7.225 4.988l-29.332 77.397c-1.512 3.99.496 8.451 4.487 9.963 3.99 1.511 8.451-.496 9.963-4.487l5.364-14.155h33.486l5.364 14.155c1.171 3.089 4.108 4.991 7.226 4.991.91 0 1.835-.162 2.736-.504 3.991-1.512 5.999-5.973 4.487-9.963zm-18.112 53.265 10.886-28.725 10.886 28.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.317 206.484c-4.267 0-7.726 3.459-7.726 7.726v77.397c0 4.267 3.459 7.726 7.726 7.726s7.726-3.459 7.726-7.726v-77.397c0-4.266-3.459-7.726-7.726-7.726z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe559"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 18.445,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.383 -.924 .924 .383 140.992 247.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.04,
    cy: 41.956,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.383 -.924 .924 .383 197.696 379.783)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.96,
    cy: 41.956,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.924 -.383 .383 .924 -6.239 52.544)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 493.555,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.924 -.383 .383 .924 -169.388 135.536)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.04,
    cy: 470.044,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.924 -.383 .383 .924 -150.721 182.363)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.96,
    cy: 470.044,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.383 -.924 .924 .383 -354.656 409.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.445,
    cy: 256,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.383 -.924 .924 .383 -225.127 175.075)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.956,
    cy: 128.96,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.383 -.924 .924 .383 -93.243 118.371)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.956,
    cy: 383.04,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.924 -.383 .383 .924 -143.389 45.213)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.555,
    cy: 256,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.924 -.383 .383 .924 -60.397 208.362)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.044,
    cy: 128.96,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.924 -.383 .383 .924 -13.571 189.694)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.044,
    cy: 383.04,
    rx: 18.445,
    ry: 18.445,
    transform: "matrix(.383 -.924 .924 .383 -63.717 670.722)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartForecastingAlerts);
export default __webpack_public_path__ + "static/media/smart-forecasting-alerts.f0bbaffdcba094f0efafc59b8fe7d02b.svg";
export { ForwardRef as ReactComponent };